import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { RefereeDiscountContext } from 'frontend/types/referral';

interface ReferralModalInfoState {
  referralModalInfoData: RefereeDiscountContext | null;
}

const referralModalInfo: Module<ReferralModalInfoState, RootState> = {
  namespaced: true,
  state: {
    referralModalInfoData: null,
  },
  mutations: {
    setValue(state: ReferralModalInfoState, value: RefereeDiscountContext): void {
      state.referralModalInfoData = value;
    },
  },
  actions: {},
};

export default referralModalInfo;
